import React, { useState, useRef } from 'react';
import { Icon, ICONS } from 'components/Icons';
import ActionLink from 'components/elements/molecules/ActionLink/ActionLink';
import InlinePopoverCard from 'components/elements/molecules/InlinePopoverCard/InlinePopoverCard';
import { Provider } from 'react-redux';
import configureStore from 'redux/configureStore';
import RectangularButton from 'components/elements/molecules/RectangularButton/RectangularButton';
import * as syllabusApi from 'services/syllabusApi';

export default function InvalidLectureTopicPopover({
  courseId,
  row,
  onChange,
}) {
  const [answer, setAnswer] = useState(null);
  const [description, setDescription] = useState('');
  const popoverRef = useRef(null);

  const saveEdit = async (skipWeek) => {
    const updatedRow = {
      ...row,
      invalidLectureTopicDescription: description,
      skipWeek,
      invalidLectureTopic: false,
    };

    try {
      await syllabusApi.updateSyllabusRow(courseId, row._id, updatedRow);
      onChange(updatedRow);
    } catch (error) {
      console.error('Error saving row:', error);
    }
  };

  function renderQuestion() {
    if (answer) {
      return null;
    }

    return (
      <div className="d-flex align-items-start">
        <Icon
          icon={ICONS.DANGER_WARNING}
          className="mr-3 flex-shrink-0 av-camel pt-1"
        />
        <div>
          We’re not sure this lecture topic should generate relevant readings.
          Should it?
          <div className="mt-1">
            <ActionLink
              label="Yes"
              linkClassName="av-blue underline"
              onClick={() => setAnswer('yes')}
            />
            <ActionLink
              label="No"
              linkClassName="ml-3 av-blue underline"
              onClick={() => {
                // saveEdit(false);
                setAnswer('no');
              }}
            />
          </div>
        </div>
      </div>
    );
  }

  function renderYes() {
    if (answer !== 'yes') {
      return null;
    }

    return (
      <div>
        <div>
          Can you tell us more about this lecture so we can generate relevant
          readings?
        </div>
        <textarea
          type="text"
          className="flex-fill mr-2 p-2 font-size-12 mt-2"
          placeholder="e.g. Students practice negotiation in a simulated M&A deal"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          rows={3}
        />
        <div className="mt-2 d-flex justify-content-end">
          <RectangularButton
            onClick={() => setAnswer(null)}
            size="small"
            className="mr-3"
          >
            Back
          </RectangularButton>
          <RectangularButton
            disabled={!description}
            darkButton={true}
            onClick={() => setAnswer('yesSuccess')}
            size="small"
          >
            Save
          </RectangularButton>
        </div>
      </div>
    );
  }

  function renderYesSuccess() {
    if (answer !== 'yesSuccess') {
      return null;
    }

    return (
      <div>
        <div className="d-flex align-items-center">
          <div
            className="bg-av-green mr-3 flex-shrink-0"
            style={{ borderRadius: '100%', width: '8px', height: '8px' }}
          ></div>
          Sounds good. We'll add this to your course description and use this to
          generate relevant readings.
        </div>
        <div className="mt-3 d-flex justify-content-end">
          <RectangularButton
            darkButton={true}
            onClick={() => {
              saveEdit(false);
            }}
            size="small"
          >
            Okay
          </RectangularButton>
        </div>
      </div>
    );
  }

  function renderNo() {
    if (answer !== 'no') {
      return null;
    }

    return (
      <div>
        <div className="d-flex align-items-center">
          <div
            className="bg-av-green mr-3 flex-shrink-0"
            style={{ borderRadius: '100%', width: '8px', height: '8px' }}
          ></div>
          Sounds good. We won't generate readings for this day.
        </div>
        <div className="mt-3 d-flex justify-content-end">
          <RectangularButton
            onClick={() => setAnswer(null)}
            size="small"
            className="mr-3"
          >
            Back
          </RectangularButton>
          <RectangularButton
            darkButton={true}
            onClick={() => {
              popoverRef.current.hide();
            }}
            size="small"
          >
            Okay
          </RectangularButton>
        </div>
      </div>
    );
  }

  function invalidLectureTopicOverlay() {
    return (
      <Provider store={configureStore()}>
        <div
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
          }}
        >
          {renderQuestion()}
          {renderYes()}
          {renderYesSuccess()}
          {renderNo()}
        </div>
      </Provider>
    );
  }

  return (
    <InlinePopoverCard
      ref={popoverRef}
      overlay={invalidLectureTopicOverlay()}
      placement="bottom"
      onExited={() => {
        if (answer === 'yesSuccess') {
          saveEdit(false);
        }

        setAnswer(null);
        setDescription('');
      }}
    >
      <div
        className="invalid-lecture-topic-trigger"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
      >
        <Icon
          icon={ICONS.DANGER_WARNING}
          className="mr-2 flex-shrink-0 av-camel cursor-pointer"
        />
        <span
          className={
            row.invalidLectureTopic ? 'syllabus-invalid-lecture-text' : ''
          }
        >
          {row.topic || row.name || ''}
        </span>
      </div>
    </InlinePopoverCard>
  );
}
